export class Oscilloscope {
  constructor(canvas) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this._resize();
    window.addEventListener('resize', () => this._resize());
  }

  _resize() {
    const rect = this.canvas.getBoundingClientRect();
    const dpr = window.devicePixelRatio;
    this.canvas.width = rect.width * dpr;
    this.canvas.height = rect.height * dpr;
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    this.width = rect.width;
    this.height = rect.height;
  }

  draw(waveformData) {
    const ctx = this.ctx;
    const w = this.width;
    const h = this.height;

    ctx.clearRect(0, 0, w + 1, h + 1);

    if (!waveformData || waveformData.length === 0) return;

    const len = waveformData.length;
    const mid = h / 2;

    // Draw multiple passes for glow effect
    const passes = [
      { width: 6, alpha: 0.08, color: '0, 255, 242' },
      { width: 4, alpha: 0.15, color: '0, 255, 242' },
      { width: 2, alpha: 0.4, color: '0, 255, 242' },
      { width: 1, alpha: 0.9, color: '0, 255, 242' },
    ];

    for (const pass of passes) {
      ctx.beginPath();
      ctx.strokeStyle = `rgba(${pass.color}, ${pass.alpha})`;
      ctx.lineWidth = pass.width;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';

      for (let i = 0; i < len; i++) {
        const x = (i / len) * w;
        const y = mid + waveformData[i] * mid * 0.8;
        if (i === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      }
      ctx.stroke();
    }
  }
}
